import { useIdentity } from '@interhyp/platform-auth';
import { ModalProvider } from '@interhyp/platform-modal';
import { useModalConfigurations } from '@interhyp/platform-module';
import './Application.module.scss';
import '@interhyp/platform-layout/esm/index.css';
import '@interhyp/platform-modal/esm/index.css';
import '@platform/elements/esm/index.css';

import { TrackingProvider } from '@interhyp/platform-tracking';
import { TranslationContextProvider } from '@interhyp/util-translation';
import { Toaster } from '@platform/elements';
import { Favicon } from '@platform/theme';
import { Helmet } from 'react-helmet';
import { Provider } from 'react-redux';

import ConsentManager from './components/ConsentManager/ConsentManager';
import { ModuleLoadingProvider } from './provider/ModuleLoadingProvider';
import { store } from './redux/store';
import { Viewport } from './views/Viewport';

import { LocalToolAreaProvider } from '@interhyp/platform-layout';

// @ts-expect-error Polyfill for node packages
window.process = { env: {} };

export function Application(): JSX.Element {
  const identity = useIdentity();
  const modals = useModalConfigurations();

  return (
    <>
      <Helmet>
        <title>Home</title>
      </Helmet>
      <Favicon />
      <ModuleLoadingProvider>
        <TrackingProvider
          companyId={identity?.companyId}
          userId={identity?.userId}
          unitId={identity?.unitId}
        >
          <Provider store={store}>
            <TranslationContextProvider>
              <LocalToolAreaProvider>
                <ModalProvider modals={modals}>
                  <ConsentManager />
                  <Toaster />
                  <Viewport />
                </ModalProvider>
              </LocalToolAreaProvider>
            </TranslationContextProvider>
          </Provider>
        </TrackingProvider>
      </ModuleLoadingProvider>
    </>
  );
}
